'use client';

import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useCallback, useContext, useMemo } from 'react';
import { IntlMessageFormat } from 'intl-messageformat';
import validateValue from '../../personly-libs-validators/src/index.js';
export { ValidatorsProvider, useValidators };
const ValidatorsContext = createContext(null);
const ValidatorsProvider = ({
  children,
  validators,
  messages,
  locale
}) => {
  const requirement_4 = useCallback(handle => {
    const validator = validators.get(handle);
    if (!validator) return '';
    const requirements = [];
    if (validator.regex) {
      const requirement = new IntlMessageFormat(messages['VALIDATORS.REGEX'], locale).format();
      requirements.push(requirement);
    }
    if (validator.min) {
      const requirement_0 = new IntlMessageFormat(messages['VALIDATORS.MIN'], locale).format({
        count: validator.min
      });
      requirements.push(requirement_0);
    }
    if (validator.max) {
      const requirement_1 = new IntlMessageFormat(messages['VALIDATORS.MAX'], locale).format({
        count: validator.max
      });
      requirements.push(requirement_1);
    }
    if (validator.typeHandle === 'URL') {
      const requirement_2 = new IntlMessageFormat(messages['VALIDATORS.TYPES.URL'], locale).format();
      requirements.push(requirement_2);
    }
    if (validator.values && validator.values.length > 0) {
      const requirement_3 = new IntlMessageFormat(messages['VALIDATORS.VALUES'], locale).format({
        values: validator.values.join(',')
      });
      requirements.push(requirement_3);
    }
    const conjunction = new IntlMessageFormat(messages['VALIDATORS.CONJUNCTION'], locale).format();
    return toSentence(requirements, conjunction);
  }, [validators, messages, locale]);
  const validate = useCallback((handle_0, value) => {
    const validator_0 = validators.get(handle_0);
    if (!validator_0) return false;
    return validateValue(validator_0, value);
  }, [validators]);
  const range = useCallback(handle_1 => {
    const validator_1 = validators.get(handle_1);
    if (!validator_1) return {
      min: 0,
      max: 0
    };
    if (!validator_1.min && !validator_1.max) return {
      min: 0,
      max: 0
    };
    if (validator_1.typeHandle === 'TEXT') {
      const min = validator_1.min || 0;
      const max = validator_1.max || 0;
      return {
        min,
        max
      };
    }
    if (validator_1.typeHandle === 'DATE') {
      const year = new Date().getUTCFullYear();
      const min_0 = year + (validator_1.min || 0);
      const max_0 = year + (validator_1.max || 0);
      return {
        min: min_0,
        max: max_0
      };
    }
    return {
      min: 0,
      max: 0
    };
  }, [validators]);
  const value_0 = useMemo(() => ({
    validate,
    requirement: requirement_4,
    range
  }), [validate, requirement_4, range]);
  return _jsx(ValidatorsContext.Provider, {
    value: value_0,
    children: children
  });
};
function useValidators() {
  const context = useContext(ValidatorsContext);
  if (!context) {
    throw new Error("useValidators requires a context!");
  }
  return context;
}
export function toSentence(requirements, conjunction) {
  return requirements.reduce((prev, next, i) => {
    if (i < requirements.length - 1) return prev.concat(`${next}, `);
    return prev.concat(conjunction.toString()).concat(' ').concat(next.toString());
  }, '');
}